import { Add } from "@mui/icons-material";
import { Box, Button, CircularProgress, TextField } from "@mui/material";
import { ChangeEvent, FormEvent, useContext, useState } from "react";
// import Feedback from "../feedback";
import { Global_CTX } from "../../contexts/global-ctx";
import {
    Api_Key_Service,
    Create_Api_Key_Payload,
} from "../../services/api-key/api-key-service";
import { ADMS_APP_MASTER_KEY } from "../../utils/constants";
import { Autocomplete } from "../Autocomplete/Autocomplete";

const initial_input: Create_Api_Key_Payload = {
    masterKey: ADMS_APP_MASTER_KEY,
    orgCode: "",
    name: "",
};

export default function API_Key_Form({ setCount }: any) {
    const [input, set_input] = useState(initial_input);
    const { feedback, set_feedback } = useContext(Global_CTX);
    // const theme = useTheme();

    console.log(process.env);

    function handle_change(
        event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) {
        set_input((curr) => ({
            ...curr,
            [event.target.name]: event.target.value,
        }));
    }

    const handle_submit = async (ev: FormEvent) => {
        ev.preventDefault();

        if (!input.orgCode) {
            set_feedback((f) => ({
                loading: false,
                show: true,
                severity: "error",
                message: { title: "Please select an organization." },
            }));
            return;
        }

        set_feedback({ ...feedback, loading: true });

        const [data, error] = await Api_Key_Service.create_api_key(input);

        if (error) {
            set_feedback({
                loading: false,
                message: { title: error.message ?? "" },
                severity: "error",
                show: true,
            });
            return;
        }

        if (data) {
            set_feedback({
                loading: false,
                message: { title: data.message ?? "" },
                severity: "success",
                show: true,
            });
            setCount((c: any) => c + 1);
        }
    };

    return (
        <form onSubmit={handle_submit}>
            <Box display="flex" gap={2} mb={2}>
                <TextField
                    label="Key Name"
                    fullWidth
                    name="name"
                    value={input.name}
                    onChange={handle_change}
                    required
                    sx={{ flex: 1 }}
                />

                <Box flex={1}>
                    <Autocomplete
                        api="/organization"
                        setOutput={(org) => {
                            set_input((curr) => ({
                                ...curr,
                                orgCode: org ? org.code : "",
                            }));
                        }}
                        labelKey={"name"}
                        label="Organization"
                    />
                </Box>

                <Button
                    sx={{ mr: "auto" }}
                    type="submit"
                    variant="contained"
                    disabled={feedback.loading || !input.orgCode}
                    startIcon={
                        feedback.loading ? (
                            <CircularProgress size="1em" />
                        ) : (
                            <Add />
                        )
                    }
                >
                    {feedback.loading
                        ? "Creating API Key..."
                        : "Create API Key"}
                </Button>
            </Box>

            {/* <Feedback /> */}
        </form>
    );
}
